import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { Response } from '../../../_shared/models';
import { Workshop } from '../models/workshop.model';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WorkshopFilterService {
  private http = inject(HttpClient);

  public getWorkshopList(accountIds: number[], cancellation: Subject<void>): Promise<Response<Workshop[]>> {
    return firstValueFrom(
      this.http.post<Response<Workshop[]>>(`${environment.apiEndpoint}/asset/lookup/workshops`, { accountIds })
        .pipe(takeUntil(cancellation))
    );
  }
}